import apiClient from "./api-client";
import StorageHelper from "../utils/storage-helper";

const getHeaders = () => ({
  headers: {
    Authorization: 'Bearer ' + StorageHelper.get('token'),
    'Content-Type': 'application/json'
  }
});

const BASE_URL = process.env.REACT_APP_DOVESAPI + 'policy/beneficiary';

export const addBeneficiary = async (policyNumber, payload) => {
  return apiClient.post(`${BASE_URL}/add?policyNumber=${policyNumber}`, payload, getHeaders());
};

export const editBeneficiary = async (policyNumber, payload) => {
  return apiClient.post(`${BASE_URL}/edit?policyNumber=${policyNumber}`, payload, getHeaders());
};

export const deleteBeneficiary = async (policyNumber, payload) => {
  return apiClient.post(`${BASE_URL}/delete?policyNumber=${policyNumber}`, payload, getHeaders());
};

export const getBeneficiaryChangeRequests = async () => {
  return apiClient.get(`${BASE_URL}/requests`, getHeaders());
};

export const approveBeneficiaryChangeRequest = async (requestId, payload) => {
  return apiClient.post(`${BASE_URL}/requests/${requestId}/approve`, payload, getHeaders());
};

export const rejectBeneficiaryChangeRequest = async (requestId, payload) => {
  return apiClient.post(`${BASE_URL}/requests/${requestId}/reject`, payload, getHeaders());
};

